import ReactDOM from 'react-dom/client';
import { App } from './root-cmp';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);